// extracted by mini-css-extract-plugin
module.exports = {"root":"_3-Z1GJZ","link":"_1zd0YG8"};